// Centralised legal copy shared between the in-app login modals and the
// public /terms and /privacy pages, so there's a single source of truth for
// each document instead of the same text duplicated across files.

// Terms governing the carriage of goods for clients/senders — shown on the
// client Login page and on the public Terms & Conditions page.
export const CARRIAGE_TERMS_TEXT = `1. These are the terms and conditions of carriage upon which Company DRIVN FREIGHT PTY
LTD (ABN 41 658 624 385) trading as DRIVN FREIGHT (herein together with its employees,
agents, and sub-contractors referred to as "the Carrier") accepts goods for carriage and/or
storage. Please note that goods should not be consigned to or left with the carrier unless
the consignor, owner and/or sender agrees to the goods being carried and/or stored upon
these terms and conditions.

2. In this Agreement unless the contrary intention appears:-
"Carrier Agreement" means any written agreement under which the Company as agent
agrees to endeavor to secure orders for the carriage of goods by a Carrier. "Company"
means DRIVN FREIGHT PTY LTD (ABN 41 658 624 385) trading as DRIVN FREIGHT (herein
together with its employees, agents, and sub-contractors referred to as "the Carrier").
"Goods" includes, but is not limited to documents. "Sender" means the person who
requests the Company to arrange the carriage of the goods. "Service" means the
transportation of goods. Where a party comprises two or more Persons the agreement shall
bind them jointly and severally. Words importing the singular shall include the plural and
vice versa. Words importing the masculine shall include all genders. Reference to any
legislation shall include any modification or re-enactment of that legislation and the parties
shall include their successors and assigns.

3. The Carrier is not a common carrier and accepts no liability as such.

4. The Carrier reserves the right in its sole discretion to refuse the carriage of Goods without
giving explanation for such refusal.

5. Responsibility for packaging, insuring and accounting for the Goods before, during and
after transit rests solely with the Sender.

6. Consignment of goods to the carrier represents a warranty by the person consigning the
goods that such person is duly authorized by the owner and/or consignor of such goods to
bind the owner and/or consignor to within the terms and conditions in respect of the
carriage and/or storage of such goods.

7. No goods will be insured by the carrier during the transit and/or storage.

8. All goods shall be and remain at risk of the consignor and/or owner and not the carrier.
The goods are in custody of under control of the carrier or its sub-contractor. The carrier
shall not be liable for any consequential loss or damage which may be sustained but the
owner of the goods. The loss or damage referred to shall mean and include without limiting
the foregoing of loss or damage caused by the negligence or willful act or default of the
carrier or others whether or not such loss or damage is foreseeable or contemplated by the
carrier.

9. The carrier shall have sole discretion as to the means of handling, loading, unloading,
carriage and storing of goods.

10. It shall be the responsibility of the person consigning the goods to the carrier to so
present the goods appropriately and properly packaged and marked and fully inform the
carrier of the description of the goods, the weight of the goods and any particular
requirements, procedures or precautions necessary for the storage/cartage of the goods.

11. It shall also be the responsibility of the person consigning the goods to the carrier to give
full and complete instructions as to the delivery address details and/or requirements for
cartage and delivery of such goods and to indemnify the carrier on behalf of the owner
and/or consignor of the goods for any loss or expense incurred by the carrier as a
consequence or any incomplete or inaccurate instructions.

12. The carrier shall be at liberty to arrange for any sub-contractors or other carrier to
perform the whole or part of the carriage of goods entrusted to the carrier and within terms
and conditions shall continue to apply in respect thereof.

13. The carrier shall have lien on all goods consigned to the carrier for storage and/or
carriage and shall be entitled to retain possession of same until all fees and charges owing
to the carrier have been pain in full.

14. The carrier declares that it is not a common carrier and does not accept liability as such
and reserves the right to refuse and carriage of goods or the carriage of any class of goods
for any person at its absolute discretion.

15. Freight charges shall be deemed earned on consignment of the goods to the carrier.

16. All accounts are payable within the payment terms mentioned in the invoice upon
receipt of the invoice. Monies outstanding after due date, incur a 2.5% charge on total
amount outstanding per month.

17. Recovery of any outstanding debt owing to the carrier shall incur costs to the account
holder associated with such recovery by either nominated debt collection agencies, court
costs or any legal remedy required including legal representation as required.

18. The Carrier shall determine the method and route of transport and method of handling
and storage of the Goods.

19. The Carrier shall be deemed to have delivered the Goods to the address given by the
Carrier if:
(a) at the address, he obtains from any person a receipt or a signed delivery docket, run
sheet or consignment note for the Goods; or
(b) there appearing to him to be no adult person in attendance at the address, he leaves the
Goods at the address.

20. The Sender warrants that he is either the owner of the Goods or is authorized to enter
into this Agreement and that any person who arranges delivery of the Goods on behalf of
the Sender is authorized to enter into this Agreement and sign any document on behalf of
the Sender.

21. The Sender shall comply with all laws relating to the packaging and transport of the
Goods and upon delivery to the Carrier shall disclose to the Carrier the nature and fragility
of the contents.

22. The Sender warrants that the Goods are not explosive, flammable or dangerous and
shall indemnify and keep indemnified the Carrier against all loss, damage and liability arising
as a consequence of a breach of this warranty.

23. The Carrier may, but is not required to, spend such sums as the Carrier may, in its sole
discretion consider necessary to preserve or protect the Goods in the event of accident,
delay or otherwise.

24. The Carrier reserves the right to vary its trading terms by giving written notice of the
variation to the Sender. The Carrier reserves the right to vary its charges at any time.

25. The Sender and the Carrier agree that the Company is entitled to be provided with such
information and reports from credit reporting agencies and elsewhere as it may request
concerning the Sender's and Carrier's credit history and ability to pay present and future
debts, in order that the Company may determine whether to provide and continue
providing credit to the Sender and Carrier, and that this Agreement may be produced as
evidence of that agreement by the Sender and the Carrier.

26. This Agreement contains the entire agreement and understanding of the parties relating
to the matters referred to in this Agreement and there is no other understanding,
agreement, warranty or representation whether express or implied binding on the parties.`;

// Terms governing drivers/independent sub-contractors — shown on the Driver
// Portal login page only (not part of the public footer).
export const DRIVER_TERMS_TEXT = `1. Purpose of the Agreement
The purpose of this agreement is to establish a formal arrangement between the Company
and its Drivers or the Contractor for the provision of transport services. The Driver will
provide transportation in Company's vehicle and the Contractor will provide transportation
of goods using their vehicle under the terms and conditions set forth in this agreement.

2. In this agreement, "Company" means DRIVN FREIGHT PTY LTD (ABN 41 658 624 385) trading
as DRIVN FREIGHT. "Sender" means the person who requests the Company to arrange the
carriage of the goods. "Service" means the transportation of goods. "Driver" refers to
persons employed by the Company to perform delivery of goods in the Company's vehicles.
"Contractor" refers to independent sub-contractors who provide transportation services of
goods using their vehicle under the terms and conditions set forth in this agreement.

3. Scope of Work
The Driver/Contractor agrees to provide transportation services for the Company, which
includes:
Transportation of goods from the specified origin to the destination as directed by the
Company.
Adherence to all delivery schedules provided by the Company.
Safe and secure transport of goods in compliance with applicable laws and regulations.

4. The Driver/Contractor is responsible for ensuring that the vehicle is in proper working
condition, fully insured, and compliant with all legal regulations.

5. This agreement does not obligate the Company to provide a minimum volume of work.

6. Responsibilities of the Contractor

The Driver/Contractor agrees to:
• Maintain the vehicle in roadworthy condition and ensure it is properly licensed and insured.
• Ensure all necessary documentation (e.g., licenses, permits, inductions) are current.
• Follow all applicable laws, traffic rules, and safety regulations.
• Payment of costs incurred as a result of traffic offences.
• Not willingly disrupt or delay the work to be conducted.
• Communicate promptly with the Company regarding any delays, breakdowns, accidents or
other issues.
• Protect and safeguard the goods being transported whilst under you control and notify the
Company immediately in case of any damage or loss.
• Ensure Dangerous goods licence and permits are current when applicable.

7. Responsibilities of the Company
The Company agrees to:
a. Provide clear instructions for each transportation assignment.
b. Ensure the goods are ready for pickup at the agreed time and place.
c. Provide prompt payment to the Contractor upon receipt of Invoice as per the terms.
d. Assist the Contractor in resolving any issues that arise during transportation.

8. Insurance and Liability
• The Contractor shall maintain full insurance coverage for their vehicle, including but not
limited to public liability, trailer in control and cargo insurance.
• The Driver/Contractor assumes full responsibility for any damage, loss, or liability caused by
negligence during the transportation of goods or whilst in control of Company assets.
• The Company will not be held liable for any loss or damage caused by the
Driver/Contractor's failure to comply with legal requirements or the terms of this
agreement.

9. Termination:
This agreement may be terminated by either party with 7 days' written notice. All accounts
must be settled by both parties prior to the end of the notice period. Both parties may
terminate the agreement immediately for just cause, including but not limited to:
• Breach of the terms of this agreement.
• Failure to comply with applicable laws and regulations.
• Misconduct or negligence.

10. Confidentiality and Non-Solicitation
The Driver/Contractor agrees not to disclose any confidential information related to the Company's
business, customers, or operations without prior written consent. In addition, the Driver/Contractor
agrees that during the term of this agreement and for a period of 60 months following its
termination, they will not, directly or indirectly:
a. Solicit business from, provide services to, or attempt to engage in any transportation or
logistics services for any customer, supplier, or client of the Company that the
Driver/Contractor was introduced to, worked with, or had contact with as a result of
this agreement.
b. If found guilty of above, Driver/Contractor will be liable for a sum of $50,000.
This clause is intended to protect the Company's business interests and shall be enforceable to the
fullest extent permitted by law.

11. Indemnification
The Driver/Contractor agrees to indemnify and hold harmless the Company from any claims,
liabilities, or damages arising out of the Contractors performance of services under this
agreement.

12. Dispute Resolution
(a) In the event of any dispute, controversy, or claim arising out of or in connection with this
Agreement, including its subject matter or any question regarding its existence, validity, or
termination ("Dispute"), the parties agree that before any party can commence proceedings
in a Tribunal or Court, the party claiming a Dispute has arisen must give written notice to the
other party, specifying the nature of the Dispute and the desired resolution ("Dispute
Notice").
(b) Within 14 days of receipt of the Dispute Notice by the other party, the parties or their
authorised representatives who have authority to resolve the matter, agree to meet to
discuss the Dispute and seek a resolution.
(c) If the parties are unable to resolve the Dispute within 21 days of the Dispute Notice, either
party may refer the Dispute to mediation.
(d) If the parties cannot mutually agree on a mediator within 7 days of the date the first party
proposes a mediator, then the parties must ask that the President of the Law Society of
Queensland to appoint a mediator.
(e) The costs of the mediator must be shared equally by the parties.
(f) If the parties cannot mutually resolve the dispute at mediation or within 14 days from the
date of mediation, then either party may commence proceedings in a Tribunal or Court of
competent jurisdiction in Queensland.
(g) Nothing in this clause will prevent either party from seeking urgent interlocutory relief.
(h) Notwithstanding the existence of a Dispute, each party must continue to perform its
obligations under this Agreement unless the performance is impossible due to the nature of
the Dispute.

13. Governing Law
This agreement shall be governed by and construed in accordance with the laws of the state of
Queensland.

14. Entire Agreement
This agreement constitutes the entire understanding between the parties and supersedes all prior
agreements, whether written or oral.`;

// Privacy Policy — structured as sections (rather than one flowing text like
// the two agreements above) since headings are how a privacy policy is
// normally navigated. Tailored to what the DRIVN platform actually collects
// and does (bookings, address book, live driver tracking, POD/e-docs, chat,
// invoicing) rather than generic boilerplate.
export const PRIVACY_POLICY_LAST_UPDATED = "15 July 2026";

export const PRIVACY_POLICY_SECTIONS = [
  {
    heading: "1. Introduction",
    body: `DRIVN FREIGHT PTY LTD (ABN 41 658 624 385), trading as DRIVN FREIGHT ("DRIVN", "we", "us", "our"), provides road freight transport and freight management services across Australia, including the client and driver portals that power those services (together, the "Platform").

This Privacy Policy explains what personal information we collect, why we collect it, how we use and disclose it, and the choices and rights you have. It applies to clients, prospective clients, drivers, independent sub-contractors, and visitors to our website.

We handle personal information in accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).`,
  },
  {
    heading: "2. Information We Collect",
    body: `The information we collect depends on how you interact with us:

Account & contact details — name, business name, email address, phone number, and login credentials for clients, drivers and staff using the Platform.

Booking & job information — pickup and drop-off addresses, contact names and phone numbers at each address, freight and item details (type, quantity, weight, volume, dimensions), service requirements (e.g. tail lift, dangerous goods, inbound connect), booking and carrier reference numbers, job dates and delivery windows, and any notes or special instructions you provide.

Address book entries — saved pickup/drop-off locations and associated contact details that you choose to store for reuse on future bookings.

Delivery evidence — proof-of-delivery photos, receiver signatures, consignment notes, and any documents you or we upload against a job (e.g. delivery orders, outturn reports, booking confirmations).

Driver & vehicle information — for drivers and sub-contractors, licence and induction details, vehicle information, and real-time GPS location while a run is active, used to track deliveries and share live status with clients.

Communications — messages sent through the in-Platform chat between clients, drivers and DRIVN staff, and correspondence such as emails and support enquiries.

Billing information — invoicing details, payment terms, and account/payment records needed to bill for services and reconcile accounts.

Technical information — standard web log data (IP address, browser type, device information) and information stored locally in your browser to keep you signed in (see "Cookies" below).`,
  },
  {
    heading: "3. How We Use Your Information",
    body: `We use personal information to:

• create and manage client, driver and staff accounts;
• plan, assign, track and deliver freight bookings, including sharing live job status and ETAs;
• generate consignment notes, invoices and statements, and manage payments and overdue accounts;
• communicate with you about a specific job, your account, or our services;
• maintain your address book so repeat bookings are faster;
• investigate and resolve delivery issues, damage or loss claims, and disputes;
• meet our legal, accounting, insurance and regulatory obligations; and
• improve the safety, reliability and performance of the Platform and our services.

We do not use your personal information for unrelated marketing without your consent, and we do not sell personal information to third parties.`,
  },
  {
    heading: "4. Location & Delivery Tracking",
    body: `To provide real-time job status and delivery ETAs, the driver app collects location data from a driver's device while a run is active. This location data is shared with DRIVN's operations team and, in summary form (e.g. estimated arrival windows and delivery status), with the client whose freight is being carried. Drivers can see how and when location data is captured as part of their onboarding with DRIVN.`,
  },
  {
    heading: "5. Cookies & Similar Technologies",
    body: `Our website and portals use browser local storage to keep you signed in between visits (for example, remembering your session so you don't need to log in on every page). We do not use third-party advertising or cross-site tracking cookies. You can clear this data at any time through your browser settings, though doing so will sign you out of the Platform.`,
  },
  {
    heading: "6. Who We Share Information With",
    body: `We disclose personal information only where necessary to run our business and deliver our services, including to:

• drivers and sub-contractors, so a job can be picked up and delivered;
• clients, limited to the information needed to track their own bookings;
• trusted service providers who process data on our behalf, such as our accounting/invoicing platform, transactional email provider (for sending consignment notes, invoices and notifications), address-lookup and mapping services, and secure cloud hosting and storage providers;
• credit reporting bodies, where relevant to assessing or managing credit terms for an account;
• professional advisers (accountants, lawyers, insurers) where reasonably required; and
• regulators, law enforcement or courts, where required or authorised by law.

Any service provider we share information with is only permitted to use it to provide the relevant service to us, and not for their own purposes.`,
  },
  {
    heading: "7. Overseas Disclosure",
    body: `Some of the service providers referred to above (for example, cloud hosting or email delivery infrastructure) may store or process data on servers located outside Australia. Where this occurs, we take reasonable steps to ensure the provider protects your information to a standard consistent with the Australian Privacy Principles.`,
  },
  {
    heading: "8. Data Storage & Security",
    body: `We store personal information in access-controlled systems and take reasonable technical and organisational steps to protect it against misuse, interference, loss, and unauthorised access, modification or disclosure — including restricting Platform access by user role (client, driver, or admin) and using encrypted connections between your device and our systems. No method of transmission or storage is completely secure, and we continually review our practices as our Platform evolves.`,
  },
  {
    heading: "9. Data Retention",
    body: `We keep personal information for as long as it is needed for the purposes described in this policy, including to meet tax, accounting, insurance and other legal record-keeping obligations (which commonly require records to be kept for at least seven years). When information is no longer required, we take reasonable steps to securely delete or de-identify it.`,
  },
  {
    heading: "10. Access, Correction & Complaints",
    body: `You may request access to, or correction of, the personal information we hold about you by contacting us using the details below. We will respond within a reasonable time.

If you believe we have breached the Australian Privacy Principles, you may lodge a complaint with us directly, or with the Office of the Australian Information Commissioner (OAIC) at oaic.gov.au.`,
  },
  {
    heading: "11. Children's Privacy",
    body: `Our services are intended for business use by adults (clients, drivers and sub-contractors) and are not directed at children. We do not knowingly collect personal information from children.`,
  },
  {
    heading: "12. Changes to This Policy",
    body: `We may update this Privacy Policy from time to time to reflect changes to our services or legal obligations. The current version will always be available on this page, together with the date it was last updated.`,
  },
  {
    heading: "13. Contact Us",
    body: `If you have a question, request or complaint about how we handle personal information, contact us at:

DRIVN FREIGHT PTY LTD (ABN 41 658 624 385)
Brisbane, Queensland, Australia
Email: hello@drivnfreight.com.au
Phone: +61 470 344 648`,
  },
];
